export default __webpack_public_path__ + "static/media/arm-left-back.a138635c.png";